import { MAX_ATTRIBUTES_COUNT } from "../../../constants";
import { SearchableSelect } from "../index";
import Typography from "../typography";
import { formatSelectOptions } from "./utils";

function Attribute({
  publicTest,
  attribute,
  currentAttributes,
  index,
  onChange,
  isSpecialAttributes,
  isHidden,
  isPreset = false,
}) {
  const label = publicTest[`${attribute}Label`];
  const values = publicTest[`${attribute}Value`];

  if (!(label && values) || isHidden) {
    return null;
  }

  const onSelectChange = ({ target: { value } }) => {
    const newState = {
      [attribute]: value,
    };

    if (isSpecialAttributes) {
      for (let i = index + 1; i <= MAX_ATTRIBUTES_COUNT; i++) {
        newState[`specialAttribute${i}`] = "";
      }
    }

    onChange(newState);
  };

  let options;
  let isDisabled = isPreset;

  if (isSpecialAttributes) {
    const prevAttributeValue =
      currentAttributes[`specialAttribute${index - 1}`];
    isDisabled = isDisabled || (index > 1 && !prevAttributeValue);
    options = formatSelectOptions(values).filter(
      option => !option.parent || option.parent === prevAttributeValue
    );
  } else {
    options = formatSelectOptions(values);
  }

  return (
    <div key={`attribute-${index}`} className="tg_attribute">
      <Typography h1>{label}</Typography>
      <SearchableSelect
        options={options}
        onChange={onSelectChange}
        value={
          currentAttributes[
            isSpecialAttributes
              ? `specialAttribute${index}`
              : `attribute${index}`
          ] || ""
        }
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default Attribute;
